// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selWidth[data-v-ab6bfa6c] {\r\n  width: 220px;\n}\n.ml10[data-v-ab6bfa6c] {\r\n  margin-left: 10px;\n}\n.mb14[data-v-ab6bfa6c] {\r\n  margin-bottom: 14px;\n}\n.inline-block[data-v-ab6bfa6c] {\r\n  display: inline-block;\n}\r\n", ""]);
// Exports
module.exports = exports;
